
import AuthModule from '../../store/auth.module'
import LogsModule from '@/store/log.module';
import { defineComponent, ref, nextTick, watch } from 'vue'
import { useI18n } from 'vue-i18n';
import exportFile from 'quasar/src/utils/export-file.js';import useQuasar from 'quasar/src/composables/use-quasar.js';
import { format } from 'date-fns'
import message from '@/model/message';
import debugrequest from '@/model/requests/debugrequest';

export default defineComponent({
    setup() {
        const { t } = useI18n({ useScope: 'global' })
        const q = useQuasar()
        const filter = ref('')
        const debug = ref(false)
        const dateFrom = ref(null)
        const dateTo = ref(null)
        const levelFilter = ref(null)
        const logmessages = ref([]);
        const autoscroll = ref(true)
        const tableRef = ref(null)
        /* AUTOSCROLL */
        watch(
            () => logmessages.value.length,
            async () => {
                if (!autoscroll.value) return

                await nextTick()

                tableRef.value?.scrollTo(logmessages.value.length - 1)
            }
        )

        return {
            q,
            t,
            filter,
            debug,
            dateFrom,
            dateTo,
            levelFilter,
            logmessages,
            autoscroll,
            tableRef,
            columns: [
                {
                    name: 'datetime', label: t('tags.dateandtime'), field: 'datetime',
                    align: 'left', style: 'width: 160px; font-size: 13px;', headerStyle: 'width: 160px; font-size: 13px;'
                },
                {
                    name: 'level', label: t('logs.level'), field: 'level',
                    align: 'left', style: 'width: 70px; font-size: 13px;', headerStyle: 'width: 70px; font-size: 13px;'
                },
                {
                    name: 'message', label: t('events.message'), field: 'message',
                    align: 'left', style: 'font-size: 12px;', headerStyle: 'font-size: 12px;'
                }
            ],
        }
    },


    mounted() {
        if (!AuthModule.isLoggedIn)
            this.$router.push("/login")
        else {
            AuthModule.getSessionDebug({ username: AuthModule.currentUser.username, debug: false }).then(
                (response) => {
                    console.log(response)
                    if (response.statusCodeValue == 200) {
                        const message = (response.body as message).message;
                        console.log(message)
                        const debugresponse: debugrequest = JSON.parse(message);
                        this.debug = debugresponse.debug
                    }
                    if (this.debug)
                        this.getAllMessages();
                },
                (error) => {
                    console.log(error)
                }
            );

        }
    },


    methods: {
        clearMessages() {
            console.log('clearMessages:', AuthModule.currentUser.username);
            LogsModule.clearAllMessagesMutation();
            AuthModule.clearSessionDebug({
                username: AuthModule.currentUser.username,
                debug: this.debug
            });
            this.getAllMessages()

        },
        onDebugChange(value?: boolean) {
            const debugValue = value ?? this.debug
            console.log('Debug changed for session:', AuthModule.currentUser.username, 'to:', debugValue);

            AuthModule.updateSessionDebug({
                username: AuthModule.currentUser.username,
                debug: debugValue
            });
            if (debugValue)
                this.getAllMessages();
        },
        formatDateTime(timestamp) {
            const date = new Date(timestamp);
            return format(date, 'dd.MM.yyyy HH:mm:ss');
        },
        customFilter(rows) {
            const needle = this.filter.toLowerCase()

            return rows.filter((row) => {
                const matchMessage = row.message.toLowerCase().includes(needle)
                const matchLevel = !this.levelFilter || row.level === this.levelFilter
                const ts = row.datetime
                const matchDateFrom = !this.dateFrom || ts >= new Date(this.dateFrom).getTime()
                const matchDateTo = !this.dateTo || ts <= new Date(this.dateTo).getTime()
                return matchMessage && matchLevel && matchDateFrom && matchDateTo
            })
        },
        wrapCsvValue(val: string) {
            let formatted = val

            formatted = formatted === void 0 || formatted === null
                ? '' : String(formatted)
            formatted = formatted.split('"').join('""')
            return `"${formatted}"`
        },
        exportTable() {
            // naive encoding to csv format
            const content = [this.columns.map(col => this.wrapCsvValue(col.label))].concat(
                this.logmessages.map(logmessage => this.columns.map(col => this.wrapCsvValue(
                    typeof col.field === 'function'
                        ? col.field(logmessage)
                        : logmessage[col.field === void 0 ? col.message : col.field]
                )).join(','))
            ).join('\r\n')

            const status = exportFile(
                'LogMessages_' + new Date().toLocaleString() + '.csv',
                content,
                'text/csv'
            )

            if (status !== true) {
                this.q.notify({
                    message: this.t('tags.browserdenied'),
                    color: 'negative',
                    icon: 'warning'
                })
            }
            else {
                this.q.notify({
                    message: this.t('tags.browserdownloaded'),
                    color: 'positive',
                    icon: 'warning'
                })
            }
        },

        getAllMessages() {
            LogsModule.getLogMessagesAction(AuthModule.currentUser.accessToken);
            this.logmessages = LogsModule.getAllMessages
        },
        truncateMessage(message: string, maxLength = 130) {
            if (!message) return '';
            return message.length > maxLength
                ? message.substring(0, maxLength) + '...'
                : message;
        },

    }
})
